import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Button, ButtonGroup, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from "@mui/material";
const UploadDropdown = (props) => {
  const { options, disabled } = props;
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };
  const handleMenuItemClick = (event, option) => {
    setOpen(false);
    if (option.action) {
      option.action();
    }
  };
  const handleMainButtonClick = () => {
    if (options.length > 0 && options[0].action) {
      options[0].action();
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ButtonGroup, { ref: anchorRef, "aria-label": "Upload button group" }, /* @__PURE__ */ React.createElement(
    Button,
    {
      variant: "contained",
      sx: {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      },
      onClick: handleMainButtonClick,
      disabled: disabled || options.length > 0 && options[0].disabled
    },
    options.length > 0 && options[0].title
  ), /* @__PURE__ */ React.createElement(
    Button,
    {
      variant: "outlined",
      sx: {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        minWidth: "32px",
        padding: "4px 8px"
      },
      size: "small",
      "aria-owns": open ? "upload-menu-list" : void 0,
      "aria-haspopup": "true",
      onClick: handleToggle,
      disabled
    },
    /* @__PURE__ */ React.createElement(ArrowDropDownIcon, null)
  )), /* @__PURE__ */ React.createElement(Popper, { sx: { zIndex: 1 }, open, anchorEl: anchorRef.current, transition: true }, ({ TransitionProps, placement }) => /* @__PURE__ */ React.createElement(
    Grow,
    {
      ...TransitionProps,
      style: {
        transformOrigin: placement === "bottom" ? "center top" : "center bottom"
      }
    },
    /* @__PURE__ */ React.createElement(Paper, { elevation: 1, id: "upload-menu-list" }, /* @__PURE__ */ React.createElement(ClickAwayListener, { onClickAway: handleClose }, /* @__PURE__ */ React.createElement(MenuList, null, options.slice(1).map((option) => /* @__PURE__ */ React.createElement(
      MenuItem,
      {
        key: option.key || option.title,
        disabled: option.disabled,
        onClick: (event) => handleMenuItemClick(event, option)
      },
      option.title
    )))))
  )));
};
UploadDropdown.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      title: PropTypes.node.isRequired,
      action: PropTypes.func.isRequired,
      disabled: PropTypes.bool
    })
  ).isRequired,
  disabled: PropTypes.bool,
  variant: PropTypes.string
};
export default UploadDropdown;
